define([
        'text!./templates/basler-select-box.html',
    ], (templateStr) => {
        return [() => ({
            restrict: 'E',
            template: templateStr,
            transclude: true,
            scope: {
                showArrow: '&',
            },
        })];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerSelectBox.js